import {} from 'vue';
import { createVue3AppPackage } from '@fiksu/vue3-app';
import { registerPiniaStore } from '../config/pinia-store';
import { registerPrimeVue } from '../config/primevue';
export async function configureApp(app) {
    await import('../styles/theme.css');
    registerPrimeVue(app);
    registerPiniaStore(app);
    return app;
}
export default createVue3AppPackage(async () => (await import('../views/oasis-layout.vue')).default, (app) => configureApp(app));
